import { PageHeader } from '@egw/components'
import { CUSTOMER_SERVICE_PHONE_NUMBER, CUSTOMER_SERVICE_PHONE_NUMBER_DISPLAY, WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'

export const BeneficiariesPage: FC = () => {
  const { t } = useTranslation('features-settings')

  return (
    <>
      <PageHeader
        subtitle={t('settings.title')}
        title={t('account_beneficiaries.title')}
        backLinkUrl={WEALTH_ROUTES.SETTINGS.path}
      />
      <div className="egw-container">
        <p className="my-lg typo-primary-base-regular text-text-body">
          {t('account_beneficiaries.add_update')}
          <br className="hidden md:flex" />
          <a
            href={`tel:${CUSTOMER_SERVICE_PHONE_NUMBER}`}
            title={t('account_beneficiaries.call')}
            rel="noopener"
            className="hover:underline text-text-action typo-primary-base-bold"
          >
            {CUSTOMER_SERVICE_PHONE_NUMBER_DISPLAY}
          </a>
        </p>
      </div>
    </>
  )
}
